module.exports = __webpack_public_path__ + "media/images/countryrect/tm-26dea024a2cd48a21d0d46873fe72729.svg";